import { nanoid } from 'nanoid';

import { FacebookIcon, InstagramIcon } from '../components/vectors';

const mainNavigation = {
  pages: [
    {
      label: 'About',
      slug: '/about/',
    },
    {
      label: 'Contact',
      slug: '/contact/',
    },
  ],
  collections: [
    {
      label: 'Jeans',
      slug: '/collections/jeans/',
    },
    {
      label: 'Capris',
      slug: '/collections/capris/',
    },
    {
      label: 'Enterizos',
      slug: '/collections/enterizos/',
    },
    {
      label: 'Shoes',
      slug: '/collections/shoes/',
    },
    {
      label: 'Shorts',
      slug: '/collections/shorts/',
    },
    {
      label: 'Skirts',
      slug: '/collections/skirts/',
    },
  ],
};

const footerNavigation = {
  column1: [
    {
      label: 'Jeans',
      slug: '/collections/jeans/',
    },
    {
      label: 'Capris',
      slug: '/collections/capris/',
    },
    {
      label: 'Enterizos',
      slug: '/collections/enterizos/',
    },
    {
      label: 'Shoes',
      slug: '/collections/shoes/',
    },
    {
      label: 'Shorts',
      slug: '/collections/shorts/',
    },
    {
      label: 'Skirts',
      slug: '/collections/skirts/',
    },
  ],
  column2: [
    {
      label: 'About',
      slug: '/about/',
    },
    {
      label: 'Contact',
      slug: '/contact/',
    },
    {
      label: 'Terms of Service',
      slug: '/terms-of-service/',
    },
    {
      label: 'Returns Policy',
      slug: '/returns-policy/',
    },
  ],
};

const socialLinks = [
  {
    id: nanoid(),
    label: 'Instagram',
    url: 'https://www.instagram.com/modalatina2444/',
    icon: InstagramIcon,
  },
  {
    id: nanoid(),
    label: 'Facebook',
    url: 'https://www.facebook.com/modalatinapmq/',
    icon: FacebookIcon,
  },
];

export { mainNavigation, socialLinks, footerNavigation };
